import type { EPaidProductType, EProductType } from '../type'

// 限制 T 为 string 类型
export function getProductValueByProductType<
  T extends EPaidProductType | EProductType,
>({
  type,
  map,
}: {
  type: T
  map: Record<
    string,
    {
      className: string
    }
  >
}) {
  return map[type] || {}
}
